export const ARIES_BUNDLE_URL =
  import.meta.env.VITE_PLAYWRIGHT_BUNDLE_URL ?? import.meta.env.VITE_ARIES_BUNDLE_URL;

// Helper function to wait for the container to be available
export const waitForContainer = (isWidgetMode: boolean) =>
  new Promise<void>((resolve) => {
    // If in widget mode, no need to wait for a container
    if (isWidgetMode) {
      resolve();
      return;
    }

    // Define the container ID
    const containerId = 'product-provided-container';

    // Set a maximum wait time (10 seconds)
    const maxWaitTime = 10000;
    const startTime = Date.now();

    const check = () => {
      const container = document.getElementById(containerId);
      const elapsedTime = Date.now() - startTime;

      if (container) {
        resolve();
      } else if (elapsedTime > maxWaitTime) {
        resolve(); // Resolve anyway to avoid blocking
      } else {
        setTimeout(check, 100); // Check every 100ms
      }
    };

    check();
  });
